'use client';
import React, { useEffect, useLayoutEffect } from 'react';

function Header() {
  return (
    <div className="header freelancer" data-scroll-index="0">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="img">
              <img src="/dark/assets/imgs/intro/freelancer.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="caption">
        <h1 className="up stroke">
          <span>I&#39;m a UI-UX</span> <span>Designer</span>
        </h1>
        <h1 className="down">
          <span>I&#39;m a UI-UX</span> <span>Designer</span>
        </h1>
      </div>
    </div>
  );
}

export default Header;
